export function getMedia (): string {
	return '(max-width:900px)'
}